import { useState } from "react";
import { ShoppingCart, Plus, Minus, Trash2 } from "lucide-react";
import { SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { useCart } from "@/context/CartContext";
import CheckoutForm from "../forms/CheckoutForm";

const CartSheet = () => {
  const { cartItems, removeFromCart, updateQuantity, total } = useCart();
  const [showCheckout, setShowCheckout] = useState(false);

  if (cartItems.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center h-full" data-testid="empty-cart">
        <SheetHeader className="w-full mb-8">
          <SheetTitle className="text-2xl font-bold" style={{ fontFamily: 'Manrope' }}>Корзина</SheetTitle>
        </SheetHeader>
        <div className="w-20 h-20 bg-[#f8fafc] rounded-2xl flex items-center justify-center mb-4">
          <ShoppingCart className="w-8 h-8 text-[#cbd5e1]" />
        </div>
        <p className="text-[#64748b]">Корзина пуста</p>
        <p className="text-[#94a3b8] text-sm mt-1">Добавьте решения из каталога</p>
      </div>
    );
  }

  return (
    <>
      <SheetHeader>
        <SheetTitle className="text-2xl font-bold" style={{ fontFamily: 'Manrope' }}>Корзина</SheetTitle>
      </SheetHeader>
      <div className="flex flex-col h-full" data-testid="cart-content">
        <div className="flex-1 overflow-y-auto py-6 space-y-4">
          {cartItems.map(item => (
            <div key={item.product.id} className="flex gap-4 p-4 bg-[#f8fafc] rounded-2xl" data-testid={`cart-item-${item.product.id}`}>
              <img src={item.product.image_url} alt={item.product.name} className="w-20 h-20 object-cover rounded-xl" />
              <div className="flex-1 min-w-0">
                <h4 className="font-semibold text-[#0f172a] truncate text-sm">{item.product.name}</h4>
                <p className="text-[#0f172a] font-bold mt-1">{item.product.price.toLocaleString()} ₽</p>
                <div className="flex items-center gap-2 mt-2">
                  <button onClick={() => updateQuantity(item.product.id, item.quantity - 1)} className="p-1.5 rounded-lg bg-white border border-[#e2e8f0] hover:bg-[#f8fafc]"><Minus className="w-3.5 h-3.5" /></button>
                  <span className="w-8 text-center font-medium text-sm">{item.quantity}</span>
                  <button onClick={() => updateQuantity(item.product.id, item.quantity + 1)} className="p-1.5 rounded-lg bg-white border border-[#e2e8f0] hover:bg-[#f8fafc]"><Plus className="w-3.5 h-3.5" /></button>
                  <button onClick={() => removeFromCart(item.product.id)} className="ml-auto p-1.5 text-[#94a3b8] hover:text-red-500 rounded-lg"><Trash2 className="w-4 h-4" /></button>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="border-t border-[#e2e8f0] pt-6 space-y-4">
          <div className="flex justify-between items-center">
            <span className="text-[#64748b]">Итого:</span>
            <span className="text-2xl font-bold text-[#0f172a]" data-testid="cart-total">{total.toLocaleString()} ₽</span>
          </div>
          <button className="w-full btn-teal h-14" onClick={() => setShowCheckout(true)} data-testid="checkout-btn">Оформить заказ</button>
        </div>
      </div>
      <Dialog open={showCheckout} onOpenChange={setShowCheckout}>
        <DialogContent className="sm:max-w-lg"><CheckoutForm onClose={() => setShowCheckout(false)} /></DialogContent>
      </Dialog>
    </>
  );
};

export default CartSheet;
